import Vue from 'vue'
import Vuex from 'vuex'
import admin from './Modules/admin';
import todo from './Modules/todo';
import jobgroup from './Modules/jobgroup';

Vue.use(Vuex)

export default new Vuex.Store({
    modules:{
        admin,
        todo,
        jobgroup
    },
})
